import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { applyConsentChoice, getStoredConsentChoice } from '../../Utilities/AnalyticsUtils';

export default function ConsentBanner() {
  const [consentChoice, setConsentChoice] = useState(() => getStoredConsentChoice());

  const isVisible = useMemo(() => consentChoice === 'pending', [consentChoice]);

  if (!isVisible) {
    return null;
  }

  function handleConsent(choice) {
    const nextChoice = applyConsentChoice(choice);
    setConsentChoice(nextChoice);
  }

  return (
    <div className="wc-consent-shell" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <div className="wc-consent-card">
        <div className="wc-consent-copy">
          <p className="wc-consent-eyebrow">Privacy choices</p>
          <h2>Allow analytics?</h2>
          <p>
            We use Google Analytics and Microsoft Clarity to understand what is working and where users
            get stuck. Essential security and login storage still works either way.
          </p>
          <p className="wc-consent-meta">
            You can review the details in our <Link to="/privacy">Privacy Policy</Link>.
          </p>
        </div>
        <div className="wc-consent-actions">
          <button
            type="button"
            className="wc-consent-button wc-consent-button-secondary"
            onClick={() => handleConsent('denied')}
          >
            Only necessary
          </button>
          <button
            type="button"
            className="wc-consent-button wc-consent-button-primary"
            onClick={() => handleConsent('granted')}
          >
            Allow analytics
          </button>
        </div>
      </div>
    </div>
  );
}
